import * as React from "react";
import { EventCardSectionItem } from "../../EventCardSectionItem";
export var renderMiniTeamsScore = function (score1, score2) {
    return React.createElement("div", { className: "rj-ev-list__mini-ev-card__scores-inner" },
        React.createElement(EventCardSectionItem, { content: score1, className: "rj-ev-list__mini-ev-card__score rj-ev-list__mini-ev-card__score-home" }),
        "-",
        React.createElement(EventCardSectionItem, { content: score2, className: "rj-ev-list__mini-ev-card__score rj-ev-list__mini-ev-card__score-away" }));
};
//# sourceMappingURL=renderMiniTeamsScore.js.map